import { Component } from 'react';
import { connect, Dispatch } from 'react-redux';
import { withRouter, RouterProps } from 'utils/route';
import { Box, Text } from '@chakra-ui/react';
import { ApplicationState } from 'reducers/types';
import { SEOHelmet } from 'components';
import { generateSEOTitle } from 'utils/seo';
import { UserModel } from 'models';
import { BuyerOrderTable, SellerOrderTable, TabGroup } from 'components';
import { UserSelectors } from 'reducers/User/selectors';
import { AuthSelectors } from 'reducers/Auth/selectors';
import { UserActions } from 'reducers/User/actions';
import { AppConstants } from 'constants/app';
import { NavigationService } from 'services';

interface UserOrdersViewProps extends RouterProps {
	user: UserModel
	userOrdersLoading: boolean;
	userLoading: boolean;
	getUserOrders: () => void;
}

class UserOrders extends Component<UserOrdersViewProps> {
	componentDidMount() {
		this.props.getUserOrders();
	}

	componentDidUpdate(prevProps: UserOrdersViewProps) {
		const { user, getUserOrders } = this.props;
		if (user.isAuthenticated() && !prevProps.user.isAuthenticated()) {
			getUserOrders();
		}
	}

	onOrderNumberClick = (orderId: string) => {
		this.props.navigate(
			NavigationService.getOrderDetailsPath(orderId)
		);
	}

	onItemNameClick = (itemId: string, itemName: string) => {
		this.props.navigate(
			NavigationService.getItemDetailsPath(itemId, itemName)
		);
	}

	renderOrdersTabs() {
		const { user, userLoading, userOrdersLoading } = this.props;
		const buyerOrders = user.orders.buyer;
		const sellerOrders = user.orders.seller;

		const buyerTabContent = (
			<BuyerOrderTable 
				orders={buyerOrders}
				onItemNameClick={this.onItemNameClick} 
				onOrderNumberClick={this.onOrderNumberClick}
				isLoading={userLoading || userOrdersLoading} />
		);

		const sellerTabContent = (
			<SellerOrderTable
				orders={sellerOrders}
				onItemNameClick={this.onItemNameClick} 
				onOrderNumberClick={this.onOrderNumberClick}
				isLoading={userLoading || userOrdersLoading} />
		);

		const labels = [
			<Text key="buyer-tab">Buyer Orders</Text>,
			<Text key="seller-tab">Seller Orders</Text>
		];

		const content = [buyerTabContent, sellerTabContent];

		return <TabGroup labels={labels} content={content} />;
	}

	render() {
		return (
			<>
				<SEOHelmet
					title={generateSEOTitle('Orders')}
					description="View your orders."
				/>
				<Box maxWidth={`${AppConstants.GRIDPAGE_WIDTH}px`} minWidth={{ base: '100%', md: `${AppConstants.GRIDPAGE_WIDTH}px` }} paddingTop={['80px', '100px', '100px']} justifySelf="center">
					{this.renderOrdersTabs()}
				</Box>
			</>
		);
	}
}

function mapStateToProps(state: ApplicationState) {
	return {
		user: UserSelectors.getUser(state),
		userLoading: UserSelectors.getUserLoading(state) || AuthSelectors.getUserLoading(state),
		userOrdersLoading: UserSelectors.getUserOrdersLoading(state),
	};
}

function mapDispatchToProps(dispatch: Dispatch<ApplicationState>) {
	return {
		getUserOrders: () => dispatch(UserActions.getUserOrders())
	};
}

export const UserOrdersView = connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(UserOrders));
